import { forwardRef } from 'react';
// @mui
import { Tooltip, ListItemText, Box } from '@mui/material';
import RoleBasedGuard from 'src/auth/RoleBasedGuard';
import Iconify from 'src/components/iconify';
import { NavItemProps } from '../types';
import { StyledItem, StyledIcon } from './styles';
import RenderItem from '../RenderItem';

// ----------------------------------------------------------------------

const NavItem = forwardRef<HTMLDivElement, NavItemProps>(
  ({ item, depth, open, active, ...other }, ref) => {

    const { title, path, icon, info, children, disabled, caption, roles, selectionArea } = item;

    const subItem = depth !== 1;

    const renderContent = (
      <StyledItem
        ref={ref}
        open={open}
        depth={depth}
        active={active}
        disabled={disabled}
        {...other}
      >
        {icon && <StyledIcon>{icon}</StyledIcon>}

        <ListItemText
          primary={`${(title)}`}
          primaryTypographyProps={{
            noWrap: true,
            sx: {
              width: 72,
              fontSize: 10,
              lineHeight: '16px',
              textAlign: 'center',
              ...(active && {
                fontWeight: 'fontWeightMedium',
              }),
              ...(subItem && {
                fontSize: 14,
                width: 'auto',
                textAlign: 'left',
              }),
            },
          }}
        />

        {caption && (
          <Tooltip title={`${(caption)}`} arrow placement="right">
            <Iconify
              icon="eva:info-outline"
              width={16}
              sx={{
                top: 11,
                left: 6,
                position: 'absolute',
              }}
            />
          </Tooltip>
        )}

        {!!children && (
          <Iconify
            width={16}
            icon="eva:chevron-right-fill"
            sx={{
              top: 11,
              right: 6,
              position: 'absolute',
            }}
          />
        )}
      </StyledItem>
    );

    const renderItem = () =>

    // Default
    (
      <Box>
        {renderContent}
      </Box>
    );
    ;

    return <RoleBasedGuard roles={roles}> <RenderItem hasChildren={!!children} selectionArea={selectionArea} renderContent={renderContent} /> </RoleBasedGuard>;
  }
);

export default NavItem;
